import { render, staticRenderFns } from "./StandardTariffTable.vue?vue&type=template&id=dd0a2ba4"
import script from "./StandardTariffTable.vue?vue&type=script&lang=js"
export * from "./StandardTariffTable.vue?vue&type=script&lang=js"
import style0 from "./standard-tariff-table.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports